export const lightTheme = {
  token: {
    colorPrimary: '#2D9CDB',
    colorBgBase: '#FFF',
    colorTextBase: '#2D9CDB',
  },
  components: {
    Radio: {
      colorPrimary: '#2D9CDB',
    },
    Switch: {
      colorPrimary: '#2D9CDB',
    },
    Divider: {
      colorSplit: '#E8E8E8',
    },
    Tree: {
      colorPrimary: '#2D9CDB',
      colorPrimaryHover: '#2D9CDB',
      colorBgContainer: 'transparent',
    },
    Drawer: {
      colorText: 'black',
    },
    Checkbox: {
      colorText: '#717171',
    },
    Button: {
      defaultColor: '#717171',
    },
    Layout: {
      headerBg: 'white',
      colorBgLayout: '#f0f1f2',
      algorithm: true,
      headerColor: '#717171',
    },
    Typography: {
      colorTextBase: '#2D9CDB',
      algorithm: true,
    },
    Segmented: {
      itemSelectedBg: 'rgba(142,212,255,0.73)',
    },
    Tooltip: {
      colorBgSpotlight: '#2D9CDB',
      colorText: 'white',
    },
    Input: {
      paddingBlock: 4,
      paddingInline: 11,
    },
    Tour: {
      closeBtnSize: 'auto',
    },
  },
};
